import { actionCreator } from '@ardoq/rxbeach';
import { ComponentMatrixDimension } from './types';

interface ComponentMatrixCollapseGroupPayload {
  dimension: ComponentMatrixDimension;
  address: (string | null)[];
}
export const componentMatrixToggleCollapseGroup =
  actionCreator<ComponentMatrixCollapseGroupPayload>(
    '[componentMatrix] COMPONENT_MATRIX_COLLAPSE_GROUP'
  );

export const bypassLimitAction = actionCreator(
  '[componentMatrix] BYPASS_LIMIT'
);

export const componentMatrixCollapseAll = actionCreator(
  '[componentMatrix] COMPONENT_MATRIX_COLLAPSE_ALL'
);
export const componentMatrixExpandAll = actionCreator(
  '[componentMatrix] COMPONENT_MATRIX_EXPAND_ALL'
);
export const componentMatrixCollapseAllRows = actionCreator(
  '[componentMatrix] COMPONENT_MATRIX_COLLAPSE_ALL_ROWS'
);
export const componentMatrixExpandAllRows = actionCreator(
  '[componentMatrix] COMPONENT_MATRIX_EXPAND_ALL_ROWS'
);
export const componentMatrixCollapseAllColumns = actionCreator(
  '[componentMatrix] COMPONENT_MATRIX_COLLAPSE_ALL_COLUMNS'
);
export const componentMatrixExpandAllColumns = actionCreator(
  '[componentMatrix] COMPONENT_MATRIX_EXPAND_ALL_COLUMNS'
);
